import React, { useState } from "react";
import { RxDoubleArrowRight } from "react-icons/rx";

import {
  AiOutlineHome,
  AiOutlineInfoCircle,
  AiOutlinePieChart,
  AiOutlineQuestionCircle,
} from "react-icons/ai";
import { BiCubeAlt } from "react-icons/bi";
import { FaExchangeAlt } from "react-icons/fa";

import { NavLink } from "react-router-dom";
import "../style/Sidebar.css";

const Sidebar = ({ children }) => {
  const [isOpen, setIsopen] = useState(true);
  const toggle = () => setIsopen(!isOpen);
  const menuItems = [
    {
      path: "/",
      name: "marketplace",
      icon: <AiOutlineHome />,
    },
    {
      path: "/nft",
      name: "Create NFT",
      icon: <BiCubeAlt />,
    },

    {
      path: "/stacking",
      name: "Staking",
      icon: <AiOutlinePieChart />,
    },

    {
      path: "/teleport",
      name: "NFT Telepoter",
      icon: <FaExchangeAlt />,
    },
    {
      path: "/about",
      name: "About us",
      icon: <AiOutlineInfoCircle />,
    },
    {
      path: "/support",
      name: "Support",
      icon: <AiOutlineQuestionCircle />,
    },
  ];
  return (
    <div className="containerBox ">
      <div
        className={`sidebar pt-2 ${isOpen ? "fullSidebar" : "smallSidebar"}`}
      >
        <div className="top_section">
          <div className={`bars ${isOpen ? "barLogo" : "fullBar"}`}>
            <RxDoubleArrowRight
              onClick={() => toggle()}
              style={{
                transform: isOpen ? "rotate(180deg)" : "",
              }}
            />
          </div>
        </div>
        <div className="sideBarHeight">
          {menuItems.map((item, index) => {
            return (
              <NavLink
                to={item.path}
                key={index}
                className="link"
                activeclassname="active"
              >
                <div className="icon"> {item.icon}</div>
                <div
                  style={{ display: isOpen ? "block" : "none" }}
                  className="link_text"
                >
                  {item.name}
                </div>
              </NavLink>
            );
          })}
        </div>
        <div className="d-flex flex-column align-items-center adjustSocial">
          <div
            className="d-flex social"
            style={{
              flexDirection: isOpen ? "row" : "column",
              marginBottom: isOpen ? "10px" : "50px",
            }}
          >
            <a
              className="socialMedia"
              href="#"
              style={{ width: isOpen ? "100px" : "40px" }}
            >
              <img src="Vector.png" alt="twitter" className="pe-2" />
              <div
                style={{ display: isOpen ? "block" : "none" }}
                className="socialText"
              >
                Twitter
              </div>
            </a>
            <a
              className="socialMedia"
              href="#"
              style={{ width: isOpen ? "100px" : "40px" }}
            >
              <img src="Vector (1).png" alt="twitter" className="pe-2" />
              <div
                style={{ display: isOpen ? "block" : "none" }}
                className="socialText"
              >
                Discord
              </div>
            </a>
          </div>
          <div
            className="d-flex social"
            style={{ flexDirection: isOpen ? "row" : "column" }}
          >
            <a
              className="socialMedia"
              href="#"
              style={{ width: isOpen ? "100px" : "40px" }}
            >
              <img src="instagram 1.png" alt="twitter" className="pe-1" />
              <div
                style={{ display: isOpen ? "block" : "none" }}
                className="socialText"
              >
                instagram
              </div>
            </a>
            <a
              className="socialMedia"
              style={{ width: isOpen ? "100px" : "40px" }}
              href="#"
            >
              <img src="Vector (2).png" alt="twitter" className="pe-3" />
              <div
                style={{ display: isOpen ? "block" : "none" }}
                className="socialText"
              >
                reddit
              </div>
            </a>
          </div>
        </div>
      </div>
      <main
        className={`${isOpen ? "lessWidth" : "fullWidth"}`}
        style={{
          paddingTop: "90px",
        }}
      >
        {children}
      </main>
    </div>
  );
};

export default Sidebar;
